<template>
  <v-card>
    <v-card-text>
      <h3>Acceleration</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'meter / square second (m/sec²)',
          val: 1
        },
        {
          text: 'centimeter / square second (cm/sec²)',
          val: 100
        },
        {
          text: 'foot / square second (ft/sec²)',
          val: 3.280839895
        },
        {
          text: 'standard gravity (grav)',
          val: 0.1019716213
        },
        {
          text: 'gal(cm/s²)',
          val: 100
        },
        {
          text: 'g-unit',
          val: 0.1019716213
        },
        {
          text: 'kilometer / square hour (km/h²)',
          val: 12960
        },
        {
          text: 'kilometer / hour second(km/h-s)',
          val: 3.6
        },
        {
          text: 'mile / hour minute(mi/h-min)',
          val: 134.21617752
        },
        {
          text: 'mile / hour second (mi/hr-s)',
          val: 2.2369362921
        },
        {
          text: 'mile / square second (mi/sec²)',
          val: 0.00062137119224
        },
        {
          text: 'inch / square second (in/s²)',
          val: 39.37007874
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// acceleration.vue?32865128